'use strict';

exports.__esModule = true;
exports.updateScrollTop = updateScrollTop;
exports.startConsecutiveToggle = startConsecutiveToggle;
var UPDATE_SCROLL_TOP = exports.UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
function updateScrollTop(scrollTop) {
  return { type: UPDATE_SCROLL_TOP, scrollTop: scrollTop };
}

var START_CONSECUTIVE_TOGGLE = exports.START_CONSECUTIVE_TOGGLE = '@@redux-devtools-log-monitor/START_CONSECUTIVE_TOGGLE';
function startConsecutiveToggle(id) {
  return { type: START_CONSECUTIVE_TOGGLE, id: id };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-devtools-log-monitor/lib/actions.js
// module id = 622
// module chunks = 0